import { render, staticRenderFns } from "./CardPokemon.vue?vue&type=template&id=395d8c32&"
import script from "./CardPokemon.vue?vue&type=script&lang=js&"
export * from "./CardPokemon.vue?vue&type=script&lang=js&"
import style0 from "./CardPokemon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports